import {CompanyUnit, CompanyUnitEntity} from "../../../model/company-unit";
import {createParamSelector, getUseQueryResultData} from "../../../util/selector-util";
import {createSelector} from "@reduxjs/toolkit";

export type CompanyUnitSelectorProps = {
  companyId?: string
  regionId?: string
};

const getRegionIdParam = createParamSelector<CompanyUnitSelectorProps | undefined, string | undefined>(params => params?.regionId);
const getCompanyIdParam = createParamSelector<CompanyUnitSelectorProps | undefined, string | undefined>(params => params?.companyId);

export const companyUnitsSelector = () => createSelector(
  [getUseQueryResultData<CompanyUnit[]>, getRegionIdParam, getCompanyIdParam],
  (data, regionId, companyId) => {
    return selectCompanyUnitsAndTransform(data ?? [], {
      regionId: regionId,
      companyId: companyId,
    });
  }
);

export const companyUnitSelector = () => createSelector(
  [getUseQueryResultData<CompanyUnit>],
  (data) => {
    return data ? transformCompanyUnit(data) : undefined;
  }
);

export const selectCompanyUnits = (values?: CompanyUnit[], selector?: CompanyUnitSelectorProps): CompanyUnit[] => {
  if (!values) {
    return [];
  }

  return values.filter((v) => {
    let filterIn = true;

    if (selector?.regionId) {
      if (selector.regionId !== v.regionId) {
        filterIn = false;
      }
    }

    if (selector?.companyId) {
      if (selector.companyId !== v.companyId) {
        filterIn = false;
      }
    }

    return filterIn;
  });
};

export const transformCompanyUnit = (value: CompanyUnit): CompanyUnitEntity => {
  return CompanyUnitEntity.from(value)
}

export const selectCompanyUnitsAndTransform = (values?: CompanyUnit[], selector?: CompanyUnitSelectorProps): CompanyUnitEntity[] => {
  const selected = selectCompanyUnits(values, selector);
  return selected.map(transformCompanyUnit);
};
